// External Dependencies:
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import objectFitImages from 'object-fit-images'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import PageTracker from 'components/PageTracker/PageTracker'

// Internal Dependencies:
import SiteLayout from 'layouts/SiteLayout'

// Redux:
import configureStore from 'store/configure-store'
const store = configureStore()

// Polyfills:
import 'es6-promise/auto'
objectFitImages()

ReactDOM.render(
	<Provider store={ store }>
		<BrowserRouter>
			<Switch>
				<Route component={ SiteLayout } />
			</Switch>
		</BrowserRouter>
	</Provider>,

	document.getElementById( 'app' )
)



// WEBPACK FOOTER //
// ./app.jsx